import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CashOut from '../components/CashOut';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function CashOutPage({ routing, routingId, source }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 9,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'true'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <CashOut routing={routing} routingId={routingId} source={source}/>
        </div>
    )
}